import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { updateUserEmail, updateUsername, updateUserPassword } from '../Login/utility';
import './Account.css';

const Account = () => {
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    
    // Form states
    const [newUsername, setNewUsername] = useState('');
    const [newEmail, setNewEmail] = useState('');
    const [password, setPassword] = useState('');
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    
    // UI states
    const [activeSection, setActiveSection] = useState('none');
    const [message, setMessage] = useState({ type: '', text: '' });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // Check if user is logged in
        const storedUsername = sessionStorage.getItem('username');
        const storedEmail = sessionStorage.getItem('email');
        
        if (!storedUsername || !storedEmail) {
            navigate('/login');
            return;
        }
        
        setUsername(storedUsername);
        setEmail(storedEmail);
    }, [navigate]);

    const handleUpdateUsername = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage({ type: '', text: '' });
        
        if (!newUsername.trim()) {
            setMessage({ type: 'error', text: 'Username cannot be empty' });
            setLoading(false);
            return;
        }

        if (newUsername === username) {
            setMessage({ type: 'error', text: 'New username is the same as your current username' });
            setLoading(false);
            return;
        }
        
        const result = await updateUsername(newUsername);
        
        if (result.success) {
            setUsername(newUsername);
            setMessage({ type: 'success', text: 'Username updated successfully!' });
            setNewUsername('');
            setActiveSection('none');
        } else {
            setMessage({ type: 'error', text: result.error });
        }
        
        setLoading(false);
    };

    const handleUpdateEmail = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage({ type: '', text: '' });
        
        if (!newEmail.trim() || !password.trim()) {
            setMessage({ type: 'error', text: 'All fields are required' });
            setLoading(false);
            return;
        }
        
        if (newEmail === email) {
            setMessage({ type: 'error', text: 'New email cannot be the same as the current email' });
            setLoading(false);
            return;
        }
        const result = await updateUserEmail(newEmail, password);
        
        if (result.success) {
            setMessage({ type: 'success', text: result.message || 'Verification email sent. Please check your inbox and follow the instructions.' });
            setNewEmail('');
            setPassword('');
            setActiveSection('none');
        } else {
            setMessage({ type: 'error', text: result.error });
        }
        
        setLoading(false);
    };

    const handleUpdatePassword = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage({ type: '', text: '' });
        
        if (!currentPassword.trim() || !newPassword.trim() || !confirmPassword.trim()) {
            setMessage({ type: 'error', text: 'All fields are required' });
            setLoading(false);
            return;
        }
        
        if (newPassword !== confirmPassword) {
            setMessage({ type: 'error', text: 'New passwords do not match' });
            setLoading(false);
            return;
        }
        
        const result = await updateUserPassword(currentPassword, newPassword);
        
        if (result.success) {
            setMessage({ type: 'success', text: 'Password updated successfully!' });
            setCurrentPassword('');
            setNewPassword('');
            setConfirmPassword('');
            setActiveSection('none');
        } else {
            setMessage({ type: 'error', text: result.error });
        }
        
        setLoading(false);
    };

    return (
        <div className="account-container">
            <h1>Account Settings</h1>
            
            {message.text && (
                <div className={`message ${message.type}`}>
                    {message.text}
                </div>
            )}
            
            <div className="account-info">
                <div className="info-row">
                    <div>
                        <h3>Username</h3>
                        <p>{username}</p>
                    </div>
                    <button 
                        onClick={() => setActiveSection(activeSection === 'username' ? 'none' : 'username')}
                        className="edit-button"
                    >
                        {activeSection === 'username' ? 'Cancel' : 'Edit'}
                    </button>
                </div>
                
                {activeSection === 'username' && (
                    <form onSubmit={handleUpdateUsername} className="edit-form">
                        <div className="form-group">
                            <label>New Username</label>
                            <input
                                type="text"
                                value={newUsername}
                                onChange={(e) => setNewUsername(e.target.value)}
                                placeholder="Enter new username"
                            />
                        </div>
                        <button type="submit" className="save-button" disabled={loading}>
                            {loading ? 'Updating...' : 'Update Username'}
                        </button>
                    </form>
                )}
                
                {/* <div className="info-row">
                    <div>
                        <h3>Email</h3>
                        <p>{email}</p>
                    </div>
                    <button 
                        onClick={() => setActiveSection(activeSection === 'email' ? 'none' : 'email')}
                        className="edit-button"
                    >
                        {activeSection === 'email' ? 'Cancel' : 'Edit'}
                    </button>
                </div>
                
                {activeSection === 'email' && (
                    <form onSubmit={handleUpdateEmail} className="edit-form">
                        <div className="form-group">
                            <label>New Email</label>
                            <input
                                type="email"
                                value={newEmail}
                                onChange={(e) => setNewEmail(e.target.value)}
                                placeholder="Enter new email"
                            />
                        </div>
                        <div className="form-group">
                            <label>Current Password</label>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Enter your password"
                            />
                        </div>
                        <button type="submit" className="save-button" disabled={loading}>
                            {loading ? 'Updating...' : 'Update Email'}
                        </button>
                    </form>
                )} */}
                
                <div className="info-row">
                    <div>
                        <h3>Password</h3>
                        <p>••••••••</p>
                    </div>
                    <button 
                        onClick={() => setActiveSection(activeSection === 'password' ? 'none' : 'password')}
                        className="edit-button"
                    >
                        {activeSection === 'password' ? 'Cancel' : 'Edit'}
                    </button>
                </div>
                
                {activeSection === 'password' && (
                    <form onSubmit={handleUpdatePassword} className="edit-form">
                        <div className="form-group">
                            <label>Current Password</label>
                            <input
                                type="password"
                                value={currentPassword}
                                onChange={(e) => setCurrentPassword(e.target.value)}
                                placeholder="Enter current password"
                            />
                        </div>
                        <div className="form-group">
                            <label>New Password</label>
                            <input
                                type="password"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                placeholder="Enter new password"
                            />
                        </div>
                        <div className="form-group">
                            <label>Confirm New Password</label>
                            <input
                                type="password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                placeholder="Confirm new password"
                            />
                        </div>
                        <button type="submit" className="save-button" disabled={loading}>
                            {loading ? 'Updating...' : 'Update Password'}
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
};

export default Account;